import React, { useState } from "react";
import Loader from "react-loader-spinner";
import httpClient from "../../../custom-hooks/httpClient";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function GenerateAccountStatement() {
  const user = useSelector((state) => state.user.user);
  const [walletNumber, setWalletNumber] = useState(user.wallets[0].account_no);
  const [email, setEmail] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    toast.info("Request processing. Please wait..");

    try {
      const { status, data } = await httpClient.get(
        "/transaction-history/statement",
        {
          params: {
            wallet_number: walletNumber,
            email: email,
            start_date: startDate,
            end_date: endDate,
          },
        },
      );

      if (status === 200) {
        toast.success(data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="col-12 col-md-9">
      <div className="card card-bleed  shadow-light-lg mb-6">
        <div className="card-header">
          <h2 className="text-primary fw-bold text-center mb-6">
            Generate Account Statement
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-6">
                <label className="text-secondary">Wallet Number</label>
                <input
                  type="text"
                  className="form-control mb-3"
                  value={walletNumber}
                  onChange={(e) => setWalletNumber(e.target.value)}
                  readOnly
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="text-secondary">Email</label>
                <input
                  type="email"
                  className="form-control mb-3"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <label className="text-secondary">Start Date</label>
                <input
                  type="date"
                  className="form-control mb-3"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div className="col-12 col-md-6">
                <label className="text-secondary">End Date</label>
                <input
                  type="date"
                  className="form-control mb-3"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
            <button
              className="btn w-100 btn-primary my-6 lift"
              type="submit"
              disabled={!walletNumber || !email || !startDate || !endDate || isSubmitting}
            >
              {isSubmitting ? (
                <Loader type="Oval" color="#fff" width={20} height={20} />
              ) : (
                'Submit'
              )}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default GenerateAccountStatement;
